import React from "react";
import { TextField, InputAdornment, makeStyles } from "@material-ui/core";
import { DatePicker } from "material-ui-pickers";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import moment from "moment";
import { isIOS } from "react-device-detect";
import { debounce, LOCALE_BY_LANGUAGE } from "../../util";
import useGetCurrentUser from "../../hooks/useGetCurrentUser";

const useStyles = makeStyles((theme) => ({
  hideDateIcon: {
    "& input::-webkit-calendar-picker-indicator": {
      display: "none",
    },
    "& input": {
      appearance: "textfield",
      MozAppearance: "textfield",
    },
  },
  datePickerPointer: {
    cursor: "pointer",
    "& input": {
      cursor: "pointer",
    },
    "& svg": {
      cursor: "pointer",
    },
  },
}));


const DatePickerByPlatform = ({ value, onChange, label, disabled, size = "medium" }) => {
  const { locale } = useGetCurrentUser();
  const classes = useStyles();
  const [inputValue, setInputValue] = React.useState(value?.format("YYYY-MM-DD") || "");
  const debouncedOnChange = React.useMemo(() => debounce(onChange), [onChange]);

  if (isIOS) {
    return (
      <TextField
        type="date"
        variant="outlined"
        fullWidth
        label={label}
        value={inputValue}
        size={size}
        onChange={(e) => {
          setInputValue(e.target.value);
          debouncedOnChange(moment(e.target.value));
        }}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CalendarTodayIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        disabled={disabled}
        className={classes.hideDateIcon}
      />
    );
  }

  return (
    <DatePicker
      format={locale === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"}
      fullWidth
      label={label}
      onChange={onChange}
      value={value ? moment(value).locale(LOCALE_BY_LANGUAGE[locale] ?? LOCALE_BY_LANGUAGE.en) : value}
      TextFieldComponent={(props) => (
        <TextField
          {...props}
          variant="outlined"
        />
      )}
      InputProps={{
        className: classes.datePickerPointer,
        endAdornment: (
          <InputAdornment position="end">
            <CalendarTodayIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      size={size}
      disabled={disabled}
    />
  );
};

export default DatePickerByPlatform;
